import React from 'react'
import { createUseStyles } from 'react-jss'

import SVG from '../SVG/SVG'

const useStyles = createUseStyles(theme => ({
    readMoreLink: {
        color: theme.colors.brushedsteel,
        fontFamily: theme.fontFamily,
        fontSize: 16,
        letterSpacing: '1px',
        lineHeight: '19px',
        position: 'relative',
        textDecoration: 'none',
        textTransform: 'uppercase',
        transition: 'all 0.3s ease-in-out',

        '& svg': {
            transition: 'all 0.3s ease-in-out',
        },

        '&:hover': {
            color: '#0056a7',

            '& svg': {
                transform: 'translate(5px)',

                '& path': {
                    fill: '#0056a7 !important',
                },
            },
        },
    },
}))

function ArrowLink(props) {
    const classes = useStyles()
    return (
        <a className={classes.readMoreLink} href={props.href}>
            {props.children}{' '}
            <SVG
                name={'Chevron'}
                className={classes.buttonIcon}
                width={7}
                height={12}
                colorOne={'#383838'}
            />
        </a>
    )
}

export default ArrowLink
